export default __webpack_public_path__ + "0dd0b87f6f15d3771a6bbeeba65fde39.png";